<div class="expand-menu" [ngStyle]="{ 'top.px': top, 'left.px': left }">
  <div class="d-flex">
    @if (levels !== 3) {
      <div class="first-menu-list">
        <ng-container *ngFor="let link of menu">
          <div class="first-menu align-items-center justify-content-between">
            @if (link.links && link.links.length > 0) {
              <a
                [routerLink]="[link.link]"
                routerLinkActive="active-submenu"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="menuClick(link)"
                class="w-100 d-flex align-items-center justify-content-between first-menu-link"
                (mouseover)="showSecondMenu(link.links)"
              >
                <span class="mr-2">{{ link.heading }}</span>
                <i (click)="mobileDevice && preventAndStop($event)" class="fa-solid fa-chevron-right px-2"></i>
              </a>
  
              @if (levels > 3 && secondMenuLinks) {
                <div class="mobile-menu-level-3">
                  <ng-container *ngTemplateOutlet="secondMenu"></ng-container>
                </div>
              }
            } @else {
              <a
                [routerLink]="[link.link]"
                routerLinkActive="active-submenu"
                [routerLinkActiveOptions]="{ exact: false }"
                class="w-100 d-flex align-items-center justify-content-between first-menu-link"
                (click)="menuClick(link)"
              >
                <span class="mr-2">{{ link.heading }}</span>
              </a>
            }
          </div>
        </ng-container>
      </div>
      @if (levels > 3 && secondMenuLinks) {
        <div class="desktop-menu-level-3">
          <ng-container *ngTemplateOutlet="secondMenu"></ng-container>
        </div>
      }
    } @else {
      <div class="two-level-menu">
        <div class="second-menu">
          <div class="d-flex secondary-menu-list">
            <ng-container *ngFor="let link of menu">
              <div class="secondary-menu">
                <div class="secondary-menu-title">
                  <a class="d-block" [routerLink]="[link.link]" (click)="menuClick(link)">
                    {{ link.heading }}
                  </a>
                </div>
                @if (link.links && link.links.length > 0) {
                  <ng-container *ngFor="let sublink of link.links">
                    <div class="third-link">
                      <a [routerLink]="[sublink.link]" (click)="menuClick(sublink)">
                        {{ sublink.heading }}
                      </a>
                    </div>
                  </ng-container>
                }
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #secondMenu>
  <div class="second-menu">
    <div class="d-flex secondary-menu-list">
      <ng-container *ngFor="let link of secondMenuLinks">
        <div class="secondary-menu">
          <div class="secondary-menu-title">
            <a class="d-block" [routerLink]="[link.link]" (click)="menuClick(link)">
              {{ link.heading }}
            </a>
          </div>
          @if (link.links && link.links.length > 0) {
            <ng-container *ngFor="let sublink of link.links">
              <div class="third-link">
                <a [routerLink]="[sublink.link]" (click)="menuClick(sublink)">
                  {{ sublink.heading }}
                </a>
              </div>
            </ng-container>
          }
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
